import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createRole,
  deleteRole,
  fetchRolePermissions,
  fetchRoles,
  updateRole,
} from "../../../services/roleService";

// Fetch Roles
export const fetchRolesAsync = createAsyncThunk(
  "roledata/fetchRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchRoles();
      return response;
    } catch (error) {
      console.error("Error fetching roles:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create Role
export const createRoleAsync = createAsyncThunk(
  "roledata/createRole",
  async (roleData, { rejectWithValue }) => {
    try {
      const response = await createRole(roleData);
      return response;
    } catch (error) {
      console.error("Error creating role:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// **Update Role**
export const updateRoleAsync = createAsyncThunk(
  "roledata/updateRole",
  async ({ roleId, roleData }, { rejectWithValue }) => {
    try {
      const response = await updateRole(roleId, roleData);
      return { roleId, updatedData: response };
    } catch (error) {
      console.error("Error updating role:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const removeRole = createAsyncThunk(
  "roledata/deleteRole",
  async (roleId, { rejectWithValue }) => {
    try {
      await deleteRole(roleId);
      return roleId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchRolePermissionsAsync = createAsyncThunk(
  "permissions/fetchRolePermissions",
  async (roleId, { rejectWithValue }) => {
    try {
      const response = await fetchRolePermissions(roleId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const initialCustomerState = {
  roledata: [],
  loading: false,
  error: null,
};

const roleSlice = createSlice({
  name: "roledata",
  initialState: initialCustomerState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Roles
      .addCase(fetchRolesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRolesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.roledata = action.payload;
      })
      .addCase(fetchRolesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create Role
      .addCase(createRoleAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createRoleAsync.fulfilled, (state, action) => {
        state.loading = false;

        const createdRole = action.payload;
        if (createdRole && createdRole.group_Name) {
          state.roledata.push(createdRole);
        } else {
          console.warn(
            "Invalid role object received from server:",
            createdRole
          );
        }
      })

      .addCase(updateRoleAsync.fulfilled, (state, action) => {
        state.loading = false;

        const { roleId, updatedData } = action.payload;

        const index = state.roledata.findIndex(
          (role) => role.group_Id === roleId
        );

        if (index !== -1) {
          state.roledata[index] = {
            ...state.roledata[index],
            ...updatedData,
          };
        } else {
          console.warn("Role to update not found:", roleId);
        }
      })

      .addCase(updateRoleAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(removeRole.fulfilled, (state, action) => {
        state.roledata = state.roledata.filter(
          (item) => item.group_Id !== action.payload
        );
      })

        // 🔄 Fetch permissions
      .addCase(fetchRolePermissionsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRolePermissionsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.rolePermissions = action.payload;
      })
      .addCase(fetchRolePermissionsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default roleSlice.reducer;
